import { render, staticRenderFns } from "./FeriadoRoute.vue?vue&type=template&id=200ca39c"
import script from "./FeriadoRoute.vue?vue&type=script&lang=js"
export * from "./FeriadoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports